export default "__VITE_ASSET__DFJkpwVE__"